import { Service } from '@roc/feature-app-core';

const url = {
  GET_BORROWER_ENTITY_BORROWERS:
    '/api/v1/document/formDocument/getBorrowerEntityBorrowers',
  UPDATE_BORROWER_ENTITY_FORM:
    '/api/v1/document/formDocument/updateBorrowerEntityForm',
  SAVE_ENTITY_BOROWERS:
    '/api/v1/document/formDocument/saveBorrowerEntityBorrowers',
  GET_BORROWER_ENTITY_AUTOMATION_STATUS:
    '/api/v1/document/formDocument/getBorrowerEntityAutomationStatus',
  GET_ALL_ENTITIES: '/api/v1/loan/borrowerEntity/getAllEntities',
  GET_BORROWER_ENTITIES_BY_LENDER_ID: '/api/v1/loan/borrowerEntity/getBorrowerEntitiesByLenderId',
};

export class BorrowerEntityService extends Service {
  getAllEntities = () => {
    return this.get(url.GET_ALL_ENTITIES, {}, { disableGlobalLoading: true });
  };

  getBorrowerEntitiesByLenderId = (lenderId: number) => {
    return this.get(
      url.GET_BORROWER_ENTITIES_BY_LENDER_ID,
      { lenderId },
      { disableGlobalLoading: true }
    );
  };

  getBorrowerEntityBorrowers = (loanId: number) => {
    return this.get(
      url.GET_BORROWER_ENTITY_BORROWERS,
      {
        loanId,
      },
      {
        disableGlobalLoading: true,
      }
    );
  };

  saveEntityBorrowers = (loanId: number, payload: object) => {
    return this.post(url.SAVE_ENTITY_BOROWERS + '?loanId=' + loanId, payload);
  };

  updateBorrowerEntityForm = (payload: object) => {
    return this.put(url.UPDATE_BORROWER_ENTITY_FORM, payload);
  };

  getBorrowerEntityAutomationStatus = (borrowerEntityId: number) => {
    return this.get(
      url.GET_BORROWER_ENTITY_AUTOMATION_STATUS,
      {
        borrowerEntityId,
      },
      {
        disableGlobalLoading: true,
      }
    );
  };
}
